<script>
import dialog2Mixin from "../mixins/dialog2";

export default {
  mixins: [dialog2Mixin],
  data() {
    return {
      images: [],
      image: '',
      description: '',
      content: '',
      notice: '',
      service: '',
      title: '服務資訊'
    }
  },
  methods: {
    getDefaultImage(images) {
      const defaultImageItems = images.filter(image => image.default) || [];

      return defaultImageItems[0]?.path || '';
    },
  }
}
</script>
<template>
  <el-dialog
    width="788px"
    :class="$style.dialogReservation"
    :visible.sync="dialog2MixinVisible"
    append-to-body
    custom-class="isStyleBase"
    @closed="$Dialog2MixinOnDestroy"
  >
    <div class="dialogReservation__title mb-4">{{ title }}</div>
    <div
      v-if="image || images && !!images[0]"
      class="dialogReservation__img mb-5"
      :style="{ backgroundImage: `url('${ image || getDefaultImage(images) }')` }"
    >
    </div>
    <div
      v-if="description || service"
      class="mb-4"
    >
      <h3 class="dialogReservation__subtitle">服務簡述</h3>
      <div
        class="lh-lg text-pre-wrap"
        v-text="description || service"
      ></div>
    </div>
    <div
      v-if="content"
      class="mb-4"
    >
      <h3 class="dialogReservation__subtitle">服務內容</h3>
      <div
        class="lh-lg text-pre-wrap"
        v-text="content"
      ></div>
    </div>
    <div
      v-if="notice"
      class="mb-4"
    >
      <h3 class="dialogReservation__subtitle">注意事項</h3>
      <div
        class="lh-lg text-pre-wrap"
        v-text="notice"
      ></div>
    </div>
  </el-dialog>
</template>
<style lang="scss" module>
.dialogReservation {
  :global {
    .dialogReservation {
      &__title {
        // @extend %FontSerifWeightJtails;

        font-size: 1.313rem;
        text-align: center;
      }
      &__img {
        padding-top: 25%;
        background-color: $color-bg-default;
        background-position: center;
        background-size: cover;
      }
      &__subtitle {
        // @extend %FontSerifWeightJtails;

        margin-bottom: 0.5rem;
      }
    }
  }
}
</style>
